


































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseOrderView extends Vue {
  public createPurchaseDelivery = Components.CreatePurchaseDelivery;
  public items: Common.PurchaseOrder[] = new Array(0);
  public params: Common.OrderQuery = new Common.OrderQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.OrderImportQuery('発注',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.OrderExportQuery('発注', this.params,Common.SalesPurchaseFlags.Purchase);
  public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'orderNo', text: '発注番号' },
    { value: 'orderDate', text: '発注日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'requestDate', text: '希望納期' },
    { value: 'warehouse', text: '入庫倉庫' },
    { value: 'receiver', text: '納入先' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '発注管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true];
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false, false];    
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseImport: boolean = false;
  public voucherTypes = Common.voucherTypes;
  public DeliveryFlags = Common.DeliveryFlags;
  @Prop() public orderNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public dlgConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//明細一括入力
  public dlgSkuConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//SKU一括入力

  // ライセンスによって表示の切り替わる項目
  // public licenseCurrencyGridItems: Common.GridItemConfiguration[] = [
  //     new Common.GridItemConfiguration('取引通貨', 120)
  // ];
  // public variableGridItems: Common.GridItemConfiguration[] = [
  //     new Common.GridItemConfiguration('税計算区分', 120),
  //     new Common.GridItemConfiguration('発注金額', 120)
  // ];
  // public licenseImportGridItems: Common.GridItemConfiguration[] = [
  //     new Common.GridItemConfiguration('前払金請求額', 150),
  //     new Common.GridItemConfiguration('前払金請求残高', 150),
  //     new Common.GridItemConfiguration('前払金残高', 120),
  //     new Common.GridItemConfiguration('支払予定日', 120)
  // ];

  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('支払伝票番号', 150),
      new Common.GridItemConfiguration('支払日', 120),
    ],
    3, // 入金日の次を可変表示項目の挿入位置に指定
    'col'
  );
  // ライセンスによって表示の切り替わる項目
  public paymentTabVariableGridItems1: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払通貨', 150),
    new Common.GridItemConfiguration('支払レート', 150)
  ];
  public paymentTabVariableGridItems2: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払金額', 150)
  ];
  public paymentTabVariableGridItems3: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払計上額', 150)
  ];

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseImport = this.$api.hasLicense(Common.licenseFlags.import);

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('発注番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 150),      
      new Common.GridItemConfiguration('発注日', 120),
      new Common.GridItemConfiguration('仕入先', 120),
      new Common.GridItemConfiguration('希望納期', 120),
      new Common.GridItemConfiguration('納入区分', 120),      
      new Common.GridItemConfiguration('入庫倉庫', 120),
      new Common.GridItemConfiguration('納入先', 120),    
      new Common.GridItemConfiguration('取引通貨', 120,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('発注金額', 120),
      new Common.GridItemConfiguration('税計算区分',120),
      new Common.GridItemConfiguration('受注区分', 120),      
      new Common.GridItemConfiguration('案件', 150),              
      new Common.GridItemConfiguration('部門', 120),
      new Common.GridItemConfiguration('担当者', 120),
      new Common.GridItemConfiguration('発注管理番号', 150),

      new Common.GridItemConfiguration('前払金請求額', 150,this.hasLicenseImport),
      new Common.GridItemConfiguration('支払予定日', 120,this.hasLicenseImport),
      new Common.GridItemConfiguration('前払金請求残高', 150,this.hasLicenseImport),
      new Common.GridItemConfiguration('前払金残高', 120,this.hasLicenseImport),
      new Common.GridItemConfiguration('前払金消込額(確定待ち)',180,this.hasLicenseImport),
      new Common.GridItemConfiguration('インポート番号', 100),      
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 120),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 120)
    );

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseImport = this.hasLicenseImport;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseImport = this.hasLicenseImport;
    // タブ表示の制御
    this.$set(this.tabVisibles, 5, this.hasLicenseImport); // 支払情報タブ
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction); // 予備項目タブ

    // 支払情報タブの表示項目制御
    this.paymentTabVariableGridItems1.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems3.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems2);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems3);
    this.paymentTabGridConfig.setVariableItems(this.paymentTabVariableGridItems1);
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;
    //明細一括入力用のグリッド
    // this.dlgConfig.setGridItemsFromCaptions(
    //   ['商品',  'SKU', '単位', '発注数量', '単価', '税区分', 'NCV', '回答納期', '入荷予定日'],
    //   [250, 200, 120, 130, 130, 120, 90, 130, 130]
    // );
    this.dlgConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200,this.$api.useStockFunction),
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('発注数量', 130),
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('NCV', 90,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('回答納期', 130),
      new Common.GridItemConfiguration('入荷予定日', 130),
    )
    this.dlgConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ
  //SKU一括入力用のグリッド
    this.dlgSkuConfig.setGridItemsFromCaptions(
      ['SKU', '受注数量', '単価'],
      [150, 150, 150]
    );
    this.dlgSkuConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ
  //SKU一括入力用のグリッド

    // 検索条件を設定する
    if(this.orderNo){
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
        
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseDelivery');
    this.$api.formatter.ensureListLoaded('workflow_purchaseInvoice');
    this.$api.formatter.ensureListLoaded('workflow_sendPayment');
  }

  public async onCreate(obj: Common.PurchaseOrder) {
    const workflows = this.$api.formatter.getOptions('workflow_purchaseOrder');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    obj.deliveryFlag = this.$api.useStockFunction ? Common.DeliveryFlags.Stock : Common.DeliveryFlags.Services;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //発注明細タブのリロード
    (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 状態から編集可能か判別する
  public isStock = Common.DeliveryFlags.Stock;
  public isDirect = Common.DeliveryFlags.Direct;
  public isEditable(item: Common.PurchaseOrder, shouldCheckOrderFlag: boolean, checkDeliveryFlag: Common.DeliveryFlags = null):boolean{
    if(shouldCheckOrderFlag && item.orderFlag == false) return false;
    if(checkDeliveryFlag != null && item.deliveryFlag != checkDeliveryFlag) return false;
    if(item.state == Common.OrderStatus.PurchaseOrderSaving) return true;
    return false;
  }
  // 完了以外の状態で編集可能
  public isEditableNoComplete(item: Common.PurchaseOrder)
  {
    if(item.state == Common.OrderStatus.PurchaseOrderCompleted) return false;
    return true;
  }

  // 仕入先変更時に仕入先の通貨を設定する
  public onChangeCustomer(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    item.onChangeCounterpart();
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }
  // 入庫そうお変更時に納入先詳細を設定する
  public onChangeWarehouse(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeWarehouse();
  }
  // 納入区分変更時にクリアする
  public onChangeDeliveryFlag(item: Common.Order){
    if (item.deliveryFlag == Common.DeliveryFlags.Stock) item.receiver = null;
    else item.warehouse = null;
  }
  // 一覧でチェックされている発注伝票
  public checkedOrders: Array<Common.Order>= new Array(0);
  public getCheckedOrders(){
    this.checkedOrders = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedOrders.push(obj);
      }
    });
  }

  // 一覧選択時に明細表示ボタンを非活化状態・支払情報タブを更新
  public onSelectedMain(index: number, selected: Common.Order) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);

    // 支払情報タブを更新
  this.totalPaymentAmountFC = 0;
  this.totalPendingAmountFC = 0;
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
  }

  // 支払処理用プロパティ
  public apSegment: Common.Segment = null;
  public apPic: string = '';
  public apWorkflowId :number = 0;
  public apCounterpart: Common.Counterpart = null;
  public apCurrencyCode: string = '';
  public apPaymentDate :Date = null;
  public apBankAccount: Common.BankAccount = null;
  public apExchageRate: number = 0;
  public get apPaymentAmountFC(): number { return this.apSettlementAmountFC + this.apCommissionAmountFC; };
  public apCommissionAmountFC: number = 0;
  public apCommissionTaxFlag: boolean = false;
  public get apSettlementAmountFC(): number {
    if(this.checkedOrders.length == 0) return 0;
    return this.checkedOrders.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };

  // 支払処理ダイアログの表示
  public showAdvancePaymentDialog() {
    this.getCheckedOrders();

    // ダイアログ表示前バリデーション
    if(this.checkedOrders.length == 0){
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].counterpart.id != order.counterpart.id).length > 0){
      this.$api.modal.show('', '同一仕入先の発注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].currencyCode != order.currencyCode).length > 0){
      this.$api.modal.show('', '同一取引通貨の発注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].segmentId != order.segmentId).length > 0){
      this.$api.modal.show('', '同一部門の発注伝票を選択して下さい。', true, null);
      return;
    }        
    if(this.checkedOrders.filter(order=> (order.state & (Common.OrderStatus.PurchaseOrderPaymentWaiting | Common.OrderStatus.PurchaseOrderPartialPaymentWaiting)) <= Common.OrderItemStatus.PurchaseOrder).length > 0){
      this.$api.modal.show('', '前払金支払待ち、または前払金一部支払の発注伝票を選択して下さい。', true, null);
      return;
    }

    // 入力項目の初期化
    this.apSegment = this.checkedOrders[0].segment; //発生部門をセット(非表示)
    this.apPic = this.$api.auth.userId;    
    this.apWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_sendPayment');
    this.apCounterpart = this.checkedOrders[0].counterpart;
    this.apCurrencyCode = this.checkedOrders[0].currencyCode;
    this.apPaymentDate = this.checkedOrders.map(order => order.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.apExchageRate = 1;
    this.apCommissionAmountFC = 0;
    this.apCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeApCurrency();
    this.getBankAccount();

    // ダイアログの表示
    (this.$refs.advancePaymentDialog as Components.ListDialog).items = this.checkedOrders;
    (this.$refs.advancePaymentDialog as Components.ListDialog).showDialog();
  }

  public async onChangeApCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.apCurrencyCode;
    query.startDate = this.apPaymentDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.apExchageRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

   public async getBankAccount(){
    const query = new Common.GetBankAccount();
    query.currencyCode = this.apCurrencyCode;
    this.$api.execute(query).then(res => {
      this.apBankAccount = res as Common.BankAccount;
    });
  }

  // 支払処理の実行
  public async submitAdvancePayment(list: Array<Common.Order>)
  {
    // クエリの設定
    var query = new Common.AdvancePaymentQuery();
    query.segment = this.apSegment;
    query.pic = this.apPic;
    query.workflowId = this.apWorkflowId;
    query.counterpart = this.apCounterpart;
    query.currencyCode = this.apCurrencyCode;
    query.paymentDate = this.apPaymentDate;
    query.bankAccount = this.apBankAccount;
    query.exchangeRate = this.apExchageRate;
    query.commissionAmountFC = this.apCommissionAmountFC;
    query.settlementAmountFC = this.apSettlementAmountFC;
    query.commissionTaxFlag = this.apCommissionTaxFlag;    
    query.orders = list;

    // 支払処理後、支払一覧へ画面遷移
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',(res as Common.Payment).paymentNo));      
    // });
    return this.$api.execute(query,true).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      var payment = res as Common.Payment;
      //支払明細タブのリロード
      this.refreshPaymentList();
      this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))]);
      return true;
    }).catch(()=>{return false;});        
  }

  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseOrder){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseOrder, sourceNo : item.orderNo},this.$el);
  }

  // 発注明細一覧へ遷移する
  public showPurchaseOrderItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseOrderItem?orderNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');  
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  updateDisabledShowItemButton(order:Common.Order){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetOrderItemQuery();
    query.orderNo = order.orderNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 入荷明細表示ボタンの非活性制御
  public disabledShowPurchaseDeliveryItemButton(item: Common.Order):boolean{
    return item.state != Common.OrderStatus.PurchaseOrderCompleted;
  }

  // 入荷明細一覧へ遷移する
  public showPurchaseDeliveryItem(){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    if(obj) {
      let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?orderNo={0}', obj.orderNo));
      window.open(routeData.href, '_blank');
    }
  }

  // 明細一括入力・SKU一括入力ボタンの非活性判別
  public disabledAddItemButton(order:Common.PurchaseOrder){
    return order.state >= Common.OrderStatus.PurchaseOrderItemsOperateWaiting;
  }

  // 明細一括入力ダイアログを表示
  public showBundleAddOrderItemDialog() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;    
    // 新規の場合にチェック
    if(parent.counterpart == null){
      this.$api.modal.show('', '得意先を指定してください。', true, null);
      return ;
    }
     var items = new Array();
    var instance = new Common.PurchaseOrderItem();
    instance.taxCode = parent.counterpart.taxCode;
    items.push(instance);
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable2(usedType: Common.UsedTypes){
    //商品識別情報,受発注メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.OrderMemo )  return true; else return false;
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.OrderItem){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Order;
    this.$api.execute(new Common.OrderGetItemPriceQuery(parent, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }
  //行追加時に税区分の初期値を設定
  public async onItemCreate(obj:Common.PurchaseOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }
public submitBundleAddOrderItemRun(){
  const items = (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).items;
  if(items.length > 0) this.submitBundleAddOrderItem(items);
}
  // 明細一括入力の実行
  public async submitBundleAddOrderItem(list: Array<Common.PurchaseOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    var items = new Array();
    await list.forEach(async obj => {
      obj.order = parent;
      items.push(obj);
    });
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Purchase);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/purchase/PurchaseOrderItem?orderNo={0}', parent.orderNo));
    // });

    return this.$api.execute(query).then(res => {
      //発注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //発注明細タブのリロード
        (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        //事後アクションダイアログを表示するためコメントアウト 
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      });
      return true;
    }).catch(()=>{return false;});    
  }

  // SKU一括入力プロパティ
  public sbaoiHeaderItem: Common.PurchaseOrderItem = new Common.PurchaseOrderItem();
  // SKU一括入力ダイアログを表示
  public showSkuBundleAddOrderItemDialog() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;    
    this.sbaoiHeaderItem = new Common.PurchaseOrderItem();
    this.sbaoiHeaderItem.taxCode = parent.counterpart.taxCode;//税区分初期値をセット
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array();
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }

  // 商品変更時に連動更新項目をサーバー側で行いそれを設定する
  public onChangeCommodity2(commodity:Common.Commodity){
    // 明細を初期化
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array(0);

    // 商品に連動する項目の取得
    this.sbaoiHeaderItem.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(this.sbaoiHeaderItem);

    if(this.sbaoiHeaderItem != null && this.sbaoiHeaderItem.commodity != null){
      // 選択した商品のSKUを一括取得
      var query = new Common.SKUMasterQuery();
      query.commodityId = this.sbaoiHeaderItem.commodity.id;
      this.$api.execute(query).then(res => {
        // SKUごとに明細を作成
        for(var sku of res.result){
          var item = (this.sbaoiHeaderItem as Common.StateObject2).copy();
          item.sku = sku as Common.SKU;
          this.getPriceAndTaxCode(item);
          (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items.push(item);
        }
      });
      // 明細を更新
      (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).$forceUpdate();
    }
  }

  // 単位変更時に単価・税区分を取得する
  public onChangePackage(){
    for(var item of (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items){
      item.package = this.sbaoiHeaderItem.package;
      this.getPriceAndTaxCode(item);
    }
  }

  // SKU一括入力の実行
  public async submitSkuBundleAddOrderItem(list: Array<Common.PurchaseOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    var items = new Array();
    for(var obj of list){
      if(obj.quantity == 0) continue;
      obj.order = parent;
      // ダイアログのヘッダ部の内容を設定
      obj.commodity = this.sbaoiHeaderItem.commodity;
      obj.commodityName = this.sbaoiHeaderItem.commodityName;
      obj.package = this.sbaoiHeaderItem.package;
      obj.taxCode = this.sbaoiHeaderItem.taxCode;
      items.push(obj);
    }
    
    if(items.length == 0){
      return this.$api.modal.showDialog('', 'いずれかの行で発注数量を指定して下さい。').then(()=>false);
    }
      //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Purchase);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/purchase/PurchaseOrderItem?orderNo={0}', parent.orderNo));
    // });
    return this.$api.execute(query).then(res => {
      //発注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res);
      //発注明細タブのリロード
       (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();       
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});      
  }

  // 支払情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPaymentAmount:number = 0;
  public totalPendingAmountFC:number = 0;  
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 支払情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffAmount = 0;
    var totalWriteoffPendingAmountFC = 0;    
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = (this.$refs.mainList as Components.ListView).selected.orderNo;
    query.isSend = true;

    // サーバーから支払情報を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.paymentJournals = res.result;
        this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            totalWriteoffAmount += obj.creditAmount;
            obj.state = Common.PaymentStatus.PaymentCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentPostWaiting;            
          }
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPaymentAmount = totalWriteoffAmount;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;      
    });
  }

  // 支払一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Withdrawal?paymentNo={0}',paymentNo));
  }
  // チェックされている発注明細を取得する
  public selectedPurchaseOrderItems(){
    return (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).selectedItems;
  }
  public allPurchaseOrderItems(){
    return (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).items;
  }  
  // 入荷処理・未着品処理ボタンの非活性判別
  public  disabledOrderItemFuncButton(order:Common.PurchaseOrder):boolean{
    return order.state == Common.OrderStatus.PurchaseOrderSaving || order.state == Common.OrderStatus.PurchaseOrderCompleted;
  }
  // 明細クローズ解除処理ボタンの非活性判別
  public  disabledOrderItemCloseCancelFuncButton(order:Common.PurchaseOrder):boolean{
    return order.state == Common.OrderStatus.PurchaseOrderSaving;
  }

  // 入荷処理ダイアログの表示
  public showCreatePurchaseDelivery(isTransitPost:boolean, all:boolean = false)
  {
    var router = this.$router;
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrder;
    let componentClass = Vue.extend(this.createPurchaseDelivery);
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: all ? this.allPurchaseOrderItems() : this.selectedPurchaseOrderItems(),
          purchaseOrderItems: this.$refs.purchaseOrderItems,
          parentMainList: this.$refs.mainList,
          isTransitPost: isTransitPost,
          order: obj,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 明細クローズ処理
  public async itemClosedQuery(isClose:boolean) {
    var selectedItems:Array<Common.PurchaseOrderItem>;
    selectedItems = this.selectedPurchaseOrderItems();
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    var targetItems:Array<Common.PurchaseOrderItem>;
    targetItems=new Array();

    // クローズ処理：注残あり、クローズ解除処理：クローズ数量あり
    if(isClose == true){
      selectedItems.forEach(item =>{
        if(item.backOrderQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', '発注残数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }else{
      selectedItems.forEach(item =>{
        if(item.closedQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', 'クローズ数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }

return this.$api.modal.showDialog('確認',String.format('選択された発注明細の{0}を0にします。よろしいですか？',isClose?'発注残数量':'クローズ数量'),false).then(()=>{
      var query = new Common.OrderItemCloseQuery();
      query.orderItems = targetItems;
      query.isClose = isClose;
      return this.$api.execute(query).then(res =>{
        //発注残・ステータスが更新されるのでリストを更新する
        (this.$refs.mainList as Components.ListView).onSubmit(res);
        //発注明細タブのリロード
        (this.$refs.purchaseOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        this.$api.modal.show('処理結果','処理が完了しました。',true,null);
        return true;
      }).catch(()=>{return false;});;
    });
  }

}
